module.exports = __webpack_public_path__ + "fonts/Assistant-variable.922abef4.ttf";